import React from 'react';
import { Button, ButtonProps } from 'antd';

interface CustomButtonProps extends ButtonProps {
  children?: React.ReactNode;
}

const PrimaryButton: React.FC<CustomButtonProps> = ({
  className,
  children,
  ...props
}) => {
  // Combine the custom class with any existing className
  const combinedClassName = `gt-btn-custom ${className || ''}`.trim();

  return (
    <Button
      className={combinedClassName}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
